import React from 'react';

const TimelineSection = () => {
  const milestones = [
    { year: '2018', title: 'Grunnleggelse', desc: 'Veiassistent AS ble stiftet i Oslo av Erik Haugen og Ingrid Solberg etter å ha identifisert et stort behov for transparente bomkostnadsberegninger i Norge.' },
    { year: '2019', title: 'Første produkt lansert', desc: 'Bomkalkulatoren ble lansert med støtte for alle norske bomstasjoner. 5 000 brukere registrerte seg i løpet av de første tre månedene.' },
    { year: '2020', title: 'Bedriftsmarkedet', desc: 'Lansering av flåtestyringsmodulen for bedrifter. Inngikk partnerskap med 12 store transportselskaper inkludert Bring og PostNord.' },
    { year: '2021', title: 'Ruteoptimalisering', desc: 'Ny AI-drevet ruteoptimaliseringsmotor reduserer bomkostnader med gjennomsnittlig 23% for aktive brukere. 40 000 registrerte brukere.' },
    { year: '2023', title: 'Nasjonal dekning', desc: 'Full dekning av alle norske bomstasjoner og ferjeruter. Lansering av mobilapp for iOS og Android med 4.7 stjerner i App Store.' },
    { year: '2025', title: 'Markedsleder', desc: 'Passerte 85 000 aktive brukere og ble kåret til Norges beste bomtjeneste av Forbrukerrådet. Åpnet kontorer i Bergen og Trondheim.' },
  ];

  return (
    <section style={{ padding: '0 24px 80px', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '48px' }}>
        <div style={{ width: '4px', height: '32px', background: '#FF5722' }} />
        <div>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722', display: 'block', marginBottom: '4px' }}>Historikk</span>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '28px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.01em' }}>Vår reise fra 2018 til i dag</h2>
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        {/* Vertical line */}
        <div style={{ position: 'absolute', left: '80px', top: 0, bottom: 0, width: '1px', background: 'rgba(255,87,34,0.2)' }} />

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {milestones?.map((m, i) => (
            <div key={i} style={{ display: 'flex', gap: '0', alignItems: 'flex-start', marginBottom: i < milestones?.length - 1 ? '0' : '0' }}>
              {/* Year */}
              <div style={{ width: '80px', flexShrink: 0, paddingTop: '28px', paddingRight: '24px', textAlign: 'right' }}>
                <span style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: '#FF5722', letterSpacing: '0.04em' }}>{m?.year}</span>
              </div>
              {/* Dot */}
              <div style={{ flexShrink: 0, paddingTop: '32px', position: 'relative', zIndex: 1 }}>
                <div style={{ width: '12px', height: '12px', background: i === milestones?.length - 1 ? '#FF5722' : 'rgba(255,87,34,0.4)', border: '2px solid #FF5722', borderRadius: '2px', transform: 'rotate(45deg)' }} />
              </div>
              {/* Content */}
              <div style={{ flex: 1, padding: '20px 0 20px 24px', borderBottom: i < milestones?.length - 1 ? '1px solid rgba(224,228,232,0.05)' : 'none' }}>
                <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '8px' }}>{m?.title}</h3>
                <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--color-muted-foreground)', lineHeight: 1.7, maxWidth: '600px' }}>{m?.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
